import jsPDF from "jspdf";

export const handleExportToPDF = async (messages, t, i18n) => {
    if (!messages || messages.length === 0) {
        console.error("No messages to export");
        return;
    }

    try {
        const pdf = new jsPDF({
            orientation: "portrait",
            unit: "mm",
            format: "a4",
            pdfVersion: "1.4", // PDF version for compatibility
        });

        const isRTL = i18n?.language === "ar"; // Check if the language is Arabic
        const pageWidth = pdf.internal.pageSize.getWidth();
        const pageHeight = pdf.internal.pageSize.getHeight();
        const margins = { horizontal: 15, vertical: 20 };
        const contentWidth = pageWidth - margins.horizontal * 2;
        const lineHeight = 8; // Line height for spacing
        let yOffset = margins.vertical; // Starting vertical position

        // Function to format messages and detect links
        const formatMessageWithLinks = (text) => {
            const regex = /\[([^\]]+)\]\(([^\)]+)\)/g; // Matches [keyword](url)
            const parts = [];
            let lastIndex = 0;

            text.replace(regex, (match, keyword, url, index) => {
                if (lastIndex < index) {
                    parts.push({ text: text.substring(lastIndex, index), isLink: false });
                }
                parts.push({ text: keyword, url, isLink: true });
                lastIndex = index + match.length;
            });

            if (lastIndex < text.length) {
                parts.push({ text: text.substring(lastIndex), isLink: false });
            }

            return parts;
        };

        // Process each message starting from index 3
        for (let i = 3; i < messages.length; i++) {
            const { type, text } = messages[i];

            // Clean text by removing ` and *
            const cleanedText = text.replace(/[`*]/g, "");

            // Get localized headers for user and assistant
            const header =
                type === "user"
                    ? t("chat.export_user")
                    : type === "assistant"
                        ? t("chat.export_assistant")
                        : type;

            // Add a new page if nearing the bottom of the current page
            if (yOffset + lineHeight > pageHeight - margins.vertical) {
                pdf.addPage();
                yOffset = margins.vertical;
            }

            // Add message type in bold
            pdf.setFont("Helvetica", "bold");
            pdf.setFontSize(12);
            pdf.text(header + ":", margins.horizontal, yOffset);
            yOffset += lineHeight;

            // Format and render the cleaned message text
            pdf.setFont("Helvetica", "normal");
            const formattedParts = formatMessageWithLinks(cleanedText);

            formattedParts.forEach((part) => {
                if (part.isLink) {
                    // Render clickable link
                    const linkWidth = pdf.getTextWidth(part.text);

                    if (yOffset + lineHeight > pageHeight - margins.vertical) {
                        pdf.addPage();
                        yOffset = margins.vertical;
                    }

                    pdf.setTextColor(0, 0, 255); // Blue for links
                    pdf.textWithLink(part.text, margins.horizontal, yOffset, { url: part.url });
                    pdf.setTextColor(0, 0, 0); // Reset to black
                } else {
                    // Wrap normal text within the page width
                    const lines = pdf.splitTextToSize(part.text, contentWidth);

                    lines.forEach((line) => {
                        if (yOffset + lineHeight > pageHeight - margins.vertical) {
                            pdf.addPage();
                            yOffset = margins.vertical;
                        }

                        pdf.text(line, margins.horizontal, yOffset);
                        yOffset += lineHeight;
                    });
                }
            });

            // Draw horizontal line after each message
            pdf.setDrawColor(0, 0, 0); // Black color for the line
            pdf.line(
                margins.horizontal, // Start X
                yOffset + 2, // Start Y (slightly below the last line of text)
                pageWidth - margins.horizontal, // End X
                yOffset + 2 // End Y
            );

            // Add spacing after each message
            yOffset += lineHeight + 2; // Add extra space for the line
        }

        // Save the PDF
        const timestamp = new Date().toISOString().split("T")[0];
        pdf.save(`chat-history-${timestamp}.pdf`);
    } catch (error) {
        console.error("PDF export failed:", error);
    }
};
